import getConfig from 'next/config';

const config = getConfig() || {};
const frontendUrl = config.publicRuntimeConfig?.FRONTEND_URL || process.env.FRONTEND_URL || '';

export function apiUrl(path) {
	if (typeof window !== 'undefined') {
		return path;
	}

	return `${frontendUrl}${path}`;
}
